import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from '@mui/material';

const AddDoctor = ({ open, onClose, onDoctorAdded }) => {
  const [newDoctor, setNewDoctor] = useState({ Name: '', Specialty: '', Phone: '' });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewDoctor((prev) => ({ ...prev, [name]: value }));
  };

  const handleAdd = async () => {
    try {
      const docRef = await addDoc(collection(db, 'hvac', 'GenericData', 'Doctors'), newDoctor);
      onDoctorAdded({ id: docRef.id, ...newDoctor });
      onClose();
    } catch (error) {
      console.error('Error adding doctor:', error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Add Doctor</DialogTitle>
      <DialogContent>
        <TextField
          label="Name"
          name="Name"
          value={newDoctor.Name}
          onChange={handleInputChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Specialty"
          name="Specialty"
          value={newDoctor.Specialty}
          onChange={handleInputChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Phone"
          name="Phone"
          value={newDoctor.Phone}
          onChange={handleInputChange}
          fullWidth
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleAdd} color="primary">
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddDoctor; 